export const BLOCKED_COLLATERALS_COUNTRIES = [
  'RU', // Russia
  'UA', // Ukraine
  'CU', // Cuba
  'IR', // Iran
  'KP', // North Korea
  'SY', // Syria
  'US', // United States
]

export const BLOCKED_COUNTRIES = [
  'AL', // Albania (Balkans)
  'BA', // Bosnia and Herzegovina (Balkans)
  'XK', // Kosovo (Balkans)
  'MK', // North Macedonia (Balkans)
  'RS', // Serbia (Balkans)
  'BY', // Belarus
  'BI', // Burundi
  'CF', // Central African Republic
  'SD', // Sudan (Darfur Region of Sudan)
  'CD', // Democratic Republic of the Congo
  'ET', // Ethiopia
  'IQ', // Iraq
  'CI', // Ivory Coast
  'LB', // Lebanon
  'LR', // Liberia
  'LY', // Libya
  'ML', // Mali
  'NI', // Nicaragua
  'SO', // Somalia
  'SS', // South Sudan
  'UA', // Ukraine
  'RU', // Russia
  'YE', // Yemen
  'ZW', // Zimbabwe
  'AF', // Afghanistan
  'MM', // Myanmar (Burma)
]

export const BLOCKED_COLLATERALS = [
  '0x57f5e098cad7a3d1eed53991d4d66c45c9af7812', // wUSDM
]
